import { useRef } from "react";
import { Camera } from "react-camera-pro";
import { Button, Box } from "@mui/material";
import { dataURLtoFile } from "./utils";

export default function ServingExampleAppInput(props) {
  const cameraRef = useRef(null);

  function handleUpload(e) {
    const imgFile = e.target.files[0];
    props.onFileChange(imgFile);
    props.onImageChange(URL.createObjectURL(imgFile));
  }

  function handleCamera() {
    const imgDataURL = cameraRef.current.takePhoto();
    props.onFileChange(dataURLtoFile(imgDataURL));
    props.onImageChange(imgDataURL);
  }

  return (
    <>
      <Box sx={{ flex: 1 }}>
        <Camera ref={cameraRef} aspectRatio={1} facingMode="environment" />
      </Box>
      <Box
        sx={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
        textAlign="center"
        color="#8c0404"
      >
        <input
          accept="image/*"
          className="upload-image"
          style={{ display: "none" }}
          id="upload-image"
          multiple
          type="file"
          onChange={handleUpload}
        />
        <Button
          color="inherit"
          variant="outlined"
          onClick={handleCamera}
          sx={{ px: "2em", py: "0.5em", mr: "1em", my: "1em" }}
        >
          Inference
        </Button>
        <label htmlFor="upload-image">
          <Button
            variant="outlined"
            component="span"
            className="upload-image"
            sx={{ px: "2em", py: "0.5em", my: "1em" }}
          >
            Or, Upload Image
          </Button>
        </label>
      </Box>
    </>
  );
}
